/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */
import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client';
import { fetch } from 'whatwg-fetch';
import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { onError } from 'apollo-link-error';

import { constructLoginRoute } from '@/router/utils';

import createCache from './graphql/client/createCache';
import { apiUrl } from '@/env';

// TODO: make the BASE_URL configurable
const uri = `${apiUrl}/graphql`;

const shouldBatchOperation = operation => {
  // Don't batch certain operations that might slow down other queries
  return ['DashboardBlockSeries'].indexOf(operation.operationName) === -1;
};

const credentialsOptions = { credentials: 'include' };

const splitLink = ApolloLink.split(
  shouldBatchOperation,
  new BatchHttpLink({ uri, batchMax: 15, ...credentialsOptions }),
  new HttpLink({ uri, fetchOptions: credentialsOptions })
);
const errorLink = onError(({ graphQLErrors, networkError }) => {
  // Handles expired sessions
  if (networkError && networkError.statusCode == 401) {
    const fullPath = window.location.pathname + window.location.search;
    window.location.href = constructLoginRoute(fullPath);
  }

  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) =>
      // eslint-disable-next-line no-console
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    );
  }
  if (networkError) {
    // eslint-disable-next-line no-console
    console.log(`[Network error]: ${networkError}`);
  }
});

const link = ApolloLink.from([errorLink, splitLink]);

const cache = createCache();

const defaultOptions = {
  wsEndpoint: null,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  websocketsOnly: false,
  ssr: false,
  // Due to IE11 does not include the Web API fetch method, here we pass to
  // apollo the polyfill to be use instead
  httpLinkOptions: {
    fetch,
  },
  apollo: {
    link,
    cache,
  },
};

export const { apolloClient } = createApolloClient({
  ...defaultOptions,
});
